var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Inline } from 'syf-component-library/ui/spacing';
import { CertificateLink, FamilyStores } from './subcomponents';
var LinksList = function (_a) {
    var links = _a.links;
    var t = useTranslation().t;
    var secondToLast = links.length - 2;
    return (_jsx(_Fragment, { children: links.map(function (link, idx) { return (_jsxs(Fragment, { children: [_jsx(CertificateLink, __assign({ isInline: true, href: link.href, target: "_blank" }, { children: link.text }), link.text), links.length > 1 && (_jsxs(_Fragment, { children: [idx < secondToLast ? ', ' : '', idx === secondToLast ? " ".concat(t('viewPrintModal.and'), " ") : ''] }))] }, link.text)); }) }));
};
var CertificatesUse = function (_a) {
    var translationViewPrintKey = _a.translationViewPrintKey, links = _a.links;
    var t = useTranslation().t;
    return (_jsxs(FamilyStores, { children: [t("viewPrintModal.".concat(translationViewPrintKey)), _jsx(Inline, { size: "xsmall" }), _jsx(LinksList, { links: links }), ".*"] }));
};
export default CertificatesUse;
